__turbopack_context__.v({
  "calendarActions": "TripOverviewPage-module__oJOchG__calendarActions",
  "calendarClear": "TripOverviewPage-module__oJOchG__calendarClear",
  "calendarPopover": "TripOverviewPage-module__oJOchG__calendarPopover",
  "container": "TripOverviewPage-module__oJOchG__container",
  "curatorsSkeleton": "TripOverviewPage-module__oJOchG__curatorsSkeleton",
  "desktopBookingCard": "TripOverviewPage-module__oJOchG__desktopBookingCard",
  "desktopBookingChevron": "TripOverviewPage-module__oJOchG__desktopBookingChevron",
  "desktopBookingChevronOpen": "TripOverviewPage-module__oJOchG__desktopBookingChevronOpen",
  "desktopBookingCta": "TripOverviewPage-module__oJOchG__desktopBookingCta",
  "desktopBookingFieldButton": "TripOverviewPage-module__oJOchG__desktopBookingFieldButton",
  "desktopBookingFieldHalf": "TripOverviewPage-module__oJOchG__desktopBookingFieldHalf",
  "desktopBookingFieldText": "TripOverviewPage-module__oJOchG__desktopBookingFieldText",
  "desktopBookingGrid": "TripOverviewPage-module__oJOchG__desktopBookingGrid",
  "desktopBookingLabel": "TripOverviewPage-module__oJOchG__desktopBookingLabel",
  "desktopBookingOrigin": "TripOverviewPage-module__oJOchG__desktopBookingOrigin",
  "desktopBookingOriginIcon": "TripOverviewPage-module__oJOchG__desktopBookingOriginIcon",
  "desktopBookingPriceButton": "TripOverviewPage-module__oJOchG__desktopBookingPriceButton",
  "desktopBookingPriceRow": "TripOverviewPage-module__oJOchG__desktopBookingPriceRow",
  "desktopBookingPromo": "TripOverviewPage-module__oJOchG__desktopBookingPromo",
  "desktopBookingTripTitle": "TripOverviewPage-module__oJOchG__desktopBookingTripTitle",
  "desktopBookingUpfront": "TripOverviewPage-module__oJOchG__desktopBookingUpfront",
  "desktopBookingValue": "TripOverviewPage-module__oJOchG__desktopBookingValue",
  "emissionsBadge": "TripOverviewPage-module__oJOchG__emissionsBadge",
  "emissionsBadgeButton": "TripOverviewPage-module__oJOchG__emissionsBadgeButton",
  "emissionsPopoverBody": "TripOverviewPage-module__oJOchG__emissionsPopoverBody",
  "emissionsPopoverContent": "TripOverviewPage-module__oJOchG__emissionsPopoverContent",
  "emissionsPopoverHeading": "TripOverviewPage-module__oJOchG__emissionsPopoverHeading",
  "emissionsPopoverItem": "TripOverviewPage-module__oJOchG__emissionsPopoverItem",
  "emissionsPopoverLabelStrong": "TripOverviewPage-module__oJOchG__emissionsPopoverLabelStrong",
  "emissionsPopoverList": "TripOverviewPage-module__oJOchG__emissionsPopoverList",
  "emissionsPopoverValueStrong": "TripOverviewPage-module__oJOchG__emissionsPopoverValueStrong",
  "emissionsRow": "TripOverviewPage-module__oJOchG__emissionsRow",
  "emissionsSummary": "TripOverviewPage-module__oJOchG__emissionsSummary",
  "heroShell": "TripOverviewPage-module__oJOchG__heroShell",
  "heroSkeleton": "TripOverviewPage-module__oJOchG__heroSkeleton",
  "introActionButton": "TripOverviewPage-module__oJOchG__introActionButton",
  "introActions": "TripOverviewPage-module__oJOchG__introActions",
  "introBlock": "TripOverviewPage-module__oJOchG__introBlock",
  "introTitle": "TripOverviewPage-module__oJOchG__introTitle",
  "introTitleRow": "TripOverviewPage-module__oJOchG__introTitleRow",
  "itineraryColumn": "TripOverviewPage-module__oJOchG__itineraryColumn",
  "mapItineraryGrid": "TripOverviewPage-module__oJOchG__mapItineraryGrid",
  "mapShell": "TripOverviewPage-module__oJOchG__mapShell",
  "mobileOnly": "TripOverviewPage-module__oJOchG__mobileOnly",
  "overview-faqs": "TripOverviewPage-module__oJOchG__overview-faqs",
  "overviewTopGrid": "TripOverviewPage-module__oJOchG__overviewTopGrid",
  "overviewTopMain": "TripOverviewPage-module__oJOchG__overviewTopMain",
  "overviewTopSide": "TripOverviewPage-module__oJOchG__overviewTopSide",
  "page": "TripOverviewPage-module__oJOchG__page",
  "postMapContent": "TripOverviewPage-module__oJOchG__postMapContent",
  "tabNavShell": "TripOverviewPage-module__oJOchG__tabNavShell",
  "topSections": "TripOverviewPage-module__oJOchG__topSections",
});
